import { render, staticRenderFns } from "./userDashboardInteractions.vue?vue&type=template&id=265449f8&scoped=true"
import script from "./userDashboardInteractions.vue?vue&type=script&lang=js"
export * from "./userDashboardInteractions.vue?vue&type=script&lang=js"
import style0 from "./userDashboardInteractions.vue?vue&type=style&index=0&id=265449f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265449f8",
  null
  
)

export default component.exports